import { Skeleton } from 'builder/Skeleton/Skeleton'
import Colors from 'builder/styles/colors'
import { AiOutput } from 'builder/modules/interview/types'
import { useI18n } from 'builder/hooks/useI18n'
import { ShowStyledHTML } from '../../../ShowStyledHTML/ShowStyledHTML'
import { Container, ContainerCardFeedback, Subtitle, Title, Value } from './styles'
const colors = {
  areas_for_improvement: Colors.Orange50,
  strengths: Colors.Green50,
}

const ideals: Record<string, string> = {
  filler_words: '0',
  pauses: '2 sec',
  words_per_minute: '150',
  lenght: '240',
  length: '240',
}
export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2.card_section`

type Props = { blur?: boolean }

export const CardWithIdeal = (props: Props & AiOutput) => {
  const { i18n } = useI18n()

  return (
    <Container data-code={props.code} $blur={props.blur}>
      <div>
        <Title>{props.headline}</Title>
        <Subtitle $color={colors[props.section]}>{`${i18n.t(`${TRANSLATION_PREFIX}.ideal`)}: ${
          ideals[props.code]
        }`}</Subtitle>
      </div>
      <Value>{props.quantitative}</Value>
    </Container>
  )
}

export const CardFeedback = (props: Props & AiOutput) => {
  if (props.blur) {
    return <CardWithIdeal data-code={props.code} {...props} blur />
  }
  return (
    <ContainerCardFeedback data-code={props.code}>
      <Subtitle $color={colors[props.section]}>{props.subtitle}</Subtitle>
      <ShowStyledHTML dangerouslySetInnerHTML={{ __html: props.feedback || '' }} />
    </ContainerCardFeedback>
  )
}

export const SkeletonCard = () => {
  return (
    <Container>
      <Skeleton width={109} height={20} />
      <Skeleton width={85} height={20} style={{ marginTop: '4px' }} />
      <Skeleton width={66} height={48} style={{ marginTop: '36px' }} />
    </Container>
  )
}
